import React from 'react';
import { Utils } from '../../services';
import { getSortedSteps } from '../../services/formLayoutGroupUtils';
import './FormRendererBreadcrumb.css';

/**
 * @param {object} props
 * @param {import('../../models/FormLayoutStep').default[]} props.steps
 * @param {string} props.lang
 * @param {string} props.style none|dots|labels|numbered
 * @param {number} props.currentIndex
 * @param {(index: number) => void} props.onJump
 */
export default function FormRendererBreadcrumb({
    steps,
    lang,
    style,
    currentIndex,
    onJump,
}) {
    const sorted = getSortedSteps(steps || []);
    if (!sorted.length || style === 'none' || !style) {
        return null;
    }

    const labelFor = (step, index) => {
        if (style === 'numbered') {
            return String(index + 1);
        }
        const bc = step.breadcrumbLabel || step.breadcrumb_label;
        const fromBc = Utils.localized_or_fallback(bc || {}, lang, '');
        if (fromBc) {
            return fromBc;
        }
        return Utils.localized_or_fallback(step.label, lang, step.name || '');
    };

    if (style === 'dots') {
        return (
            <div className="FormRendererBreadcrumb FormRendererBreadcrumb--dots mb-3" role="navigation" aria-label="steps">
                {sorted.map((step, index) => {
                    const clickable = index < currentIndex;
                    const active = index === currentIndex;
                    const done = index < currentIndex;
                    return (
                        <button
                            key={step.id}
                            type="button"
                            className={`FormRendererBreadcrumb__dot ${active ? 'is-active' : ''} ${done ? 'is-done' : ''}`}
                            disabled={!clickable}
                            onClick={() => clickable && onJump(index)}
                            title={labelFor(step, index)}
                            aria-current={active ? 'step' : undefined}
                        >
                            <span className="sr-only">{labelFor(step, index)}</span>
                        </button>
                    );
                })}
            </div>
        );
    }

    return (
        <ol className={`FormRendererBreadcrumb FormRendererBreadcrumb--${style} mb-3`}>
                {sorted.map((step, index) => {
                const clickable = index < currentIndex;
                const active = index === currentIndex;
                return (
                    <li
                        key={step.id}
                        className={`FormRendererBreadcrumb__item ${active ? 'is-active' : ''}`}
                    >
                        {clickable ? (
                            <button type="button" className="FormRendererBreadcrumb__link" onClick={() => onJump(index)}>
                                {labelFor(step, index)}
                            </button>
                        ) : (
                            <span className={active ? 'font-weight-bold' : 'text-muted'}>{labelFor(step, index)}</span>
                        )}
                    </li>
                );
            })}
        </ol>
    );
}
